/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import axios from 'axios'
import { BFF_BASE_URL } from './environment'

export const appApiBff = axios.create({
  baseURL: BFF_BASE_URL,
  headers: { 'Content-type': 'application/json' }
})
